import React, { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";

import Header from "@/components/molecules/Header";
import { ReactComponent as Spinner } from "@/assets/images/spinner.svg";
import { Title } from "@/components/atoms/Typography/styles";
import i18n from "@/translate/i18n";

import { LayoutWrapper } from "@/components/molecules/Wrappers/LayoutWrapper";

const TIME_TO_REDIRECT = 10000;

const isValidUrl = (urlString) => {
  if (!urlString) return false;
  try {
    return Boolean(new URL(urlString));
  } catch (e) {
    return false;
  }
};

function TransactionAlreadyPaid() {
  const location = useLocation();
  const transactionData = location.state?.transactionData;

  const validProcessingUrl = useMemo(
    () =>
      isValidUrl(transactionData?.redirect_url_processing)
        ? transactionData.redirect_url_processing
        : null,
    [transactionData?.redirect_url_processing],
  );

  const validSuccessUrl = useMemo(
    () =>
      isValidUrl(transactionData?.redirect_url_success)
        ? transactionData.redirect_url_success
        : null,
    [transactionData?.redirect_url_success],
  );

  useEffect(() => {
    if (!validProcessingUrl && !validSuccessUrl) {
      return () => {};
    }

    const timer = setTimeout(() => {
      if (validProcessingUrl) {
        window.location.href = validProcessingUrl;
      } else if (validSuccessUrl) {
        window.location.href = validSuccessUrl;
      }
    }, TIME_TO_REDIRECT);
    return () => {
      clearTimeout(timer);
    };
  }, [validProcessingUrl, validSuccessUrl]);

  return (
    <div className="flex justify-center items-center bg-white sm:bg-gray-900 font-arboria-book min-h-screen overflow-x-hidden">
      <div className="flex flex-col justify-between items-center w-[500px] rounded-[20px] overflow-hidden text-center">
        <Header title={i18n.t("header.return")} />
        <LayoutWrapper className="!justify-center">
          <div className="flex flex-col items-center">
            <Spinner className="w-28" />
            <div>
              <Title>{i18n.t("transactionPaid.title")}</Title>
            </div>
            <h3 className="mt-5 mb-28 font-medium text-md text-black">
              {i18n.t("transactionPaid.message")}
            </h3>
          </div>
        </LayoutWrapper>
      </div>
    </div>
  );
}

export default TransactionAlreadyPaid;
